module.exports = __webpack_public_path__ + "museosans500-webfont.23bd5c92f24c4ba1f6b7.woff";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans500-webfont.woff
// module id = ../../../../../css/fonts/museosans500-webfont.woff
// module chunks = styles